import { render } from "./AddPassenger.vue?vue&type=template&id=47c3c744"
import script from "./AddPassenger.vue?vue&type=script&lang=js"
export * from "./AddPassenger.vue?vue&type=script&lang=js"

import "./AddPassenger.vue?vue&type=style&index=0&id=47c3c744&lang=css"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__